const defaultSettings = {
  general: {
    items_all_button: {
      min_requested_quantity: 5,
      at_least_one_product_manually: true,
    },
    show_position_suggestions: true,
  },
  locations: [],
  shipments: {
    dont_print_packing_slip_for_destination_locations: [],
    always_unpack_inbound_shipments: true,
    show_create_shipment_button_mobile: false,
  },
};

export default defaultSettings;
